
    import { mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faArrowLeft as farArrowLeft,
    } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
    import JobViewApplyMixin from '@/components/JobView/Mixins/JobViewApplyMixin';
    import JobViewMixin from '@/components/JobView/Mixins/JobViewMixin';
    import ScoreButton from '@/components/Scoring/ScoreButton';
    import JobViewBrandLocation from '@/components/JobView/JobViewBrandLocation';

    export default {
        name: 'JobViewApplySticky',

        components: {
            JobViewBrandLocation,
            ScoreButton,
            FontAwesomeIcon,
        },

        mixins: [JobViewApplyMixin, JobViewMixin],

        data() {
            return {
                showPromptModal: false,
                onBoardingPrompt: {
                    component_name: 'OnBoardingPrompt',
                    layout: 'lg',
                    code: 'ON_BOARDING_PROMPT',
                    page_referral_element: 'score_button',
                },
                icons: {
                    farArrowLeft,
                },
            };
        },

        computed: {
            ...mapGetters('jobModal', {
                $_isJobModalOpen: 'isJobModalOpen',
            }),
        },

        methods: {
            openPromptModal() {
                this.showPromptModal = true;
            },

            closePromptModal() {
                this.showPromptModal = false;
            },
        },
    };
